import { Link } from 'react-router-dom';
import { businesses } from '@/mocks/businesses';
import BusinessCard from '@/components/base/BusinessCard';

export default function FeaturedBusinesses() {
  const featured = businesses.filter((b) => b.featured);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            推荐企业
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            精选优质认证企业，涵盖多个热门行业，信誉可靠，值得信赖
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((biz) => (
            <BusinessCard key={biz.id} business={biz} />
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/canyin-meishi"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer"
          >
            浏览更多企业
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}